module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/middlePlatform/asset/dream_plan_banner.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/middlePlatform/asset/dream_plan_banner.png
// module id = 2034
// module chunks = 367